import MlsDataConverter from '@/converters/2.6/MlsDataConverter';
import IComp from '@/models/Comp';
import CompsUtils from '@/models/comp/CompsUtils';
import MlsPropertyItemUtils from '@/models/mls/MlsPropertyItemUtils';
import IMLSPropertyItem from '@/models/mls/IMLSPropertyItem';
import HostExchangeService from '@/services/2.6/HostExchangeService';
import { Actions, Getters, mlsStore, store } from '@/store';
import { newProcessCompRequest } from '@/store/2.6/models/IProcessCompRequest';

/**
 * MLS fetch management. Handle fetching MLS data from the report (via HostExchange) and
 * placing any result in the MLS store. This is done prior to loading of the comps.
 */
export default {
    /**
     * Fetchs MLS properties from the host and adds/replaces them in the MLS store.
     * @returns the count of those added (doesn't include those replaced)
     */
    async fetchAndStore(): Promise<number> {
        let addedCount = 0;

        const hostExchange = HostExchangeService.getInstance();
        const mlsDataVersions = await hostExchange.getMlsDataFromReport();
        if (mlsDataVersions.propertyData) {
            for (const propertyItem of mlsDataVersions.propertyData) {
                // Assure the new mediaUrls property exists.
                // May not be in the JSON of a previously saved MLS report file.
                if (!propertyItem.mediaUrls) {
                    propertyItem.mediaUrls = [];
                }

                const added = await mlsStore.addOrReplaceProperty(propertyItem);
                if (added) {
                    addedCount++;
                }
            }
            //console.log(`MlsFetchManager.fetchAndStore(), Fetched and stored [${mlsDataVersions.propertyData.length}] properties.`);
        }
        //console.log(`MlsFetchManager.fetchAndStore(), Done.`);

        return addedCount;
    },

    /**
     * Process all MLS properties within the MLS store. Received them from Total (fetch).
     * Should be called after Comps are loaded and MLS Properties are fetched.
     */
    async processToComps() {
        if (mlsStore.HasProperties) {
            // Get the MLS properties and convert each into a comp
            const mlsPropertyData = mlsStore.MlsProperties;
            const mlsComps = MlsDataConverter.convertForCompsUpdate(mlsPropertyData);

            for (const mlsComp of mlsComps) {
                const processCompRequest = newProcessCompRequest(mlsComp);
                store.dispatch(Actions.CompAddresses.ProcessComp, processCompRequest); // not awaiting
            }
        }
    },

    /**
     * Cleanup fetched MLS properties. After loading and processing comps there may be fetched
     * MLS properties that do not have a corresponding comp. This occurs when the user deleted
     * comp(s) in Total which originated from an MLS import in QS and then loaded the report in
     * QS again.
     */
    async cleanupMlsStore() {
        const removes: IMLSPropertyItem[] = [];
        const comps: IComp[] = store.getters[Getters.CompAddresses.Comps];
        const mlsPropertyData = mlsStore.MlsProperties;

        // Find the MLS properties w/o a corresponding comp
        for (const mlsPropertyItem of mlsPropertyData) {
            const address1UnitNoZipCode = MlsPropertyItemUtils.getAddress1UnitNoAndZipCode(mlsPropertyItem);
            const comp = CompsUtils.getByAddress1UnitNoAndZipCode(comps, address1UnitNoZipCode);
            if (!comp) {
                removes.push(mlsPropertyItem);
            }
        }

        // Remove any we found
        if (removes.length > 0) {
            for (const mlsProperty of removes) {
                await mlsStore.removeProperty(mlsProperty);
            }

            console.log(`MlsFetchManager.cleanupMlsStore(), Done. Removed [${removes.length}] properties.`);
        }
    }
};
